export type Locale = 'es' | 'en' | 'pt';

export const DEFAULT_LOCALE: Locale = 'es';
export const EN_PREFIX = '/en';
export const PT_PREFIX = '/pt';

export function getLocaleFromPathname(pathname: string): Locale {
  if (pathname === EN_PREFIX || pathname.startsWith(EN_PREFIX + '/')) {
    return 'en';
  }
  if (pathname === PT_PREFIX || pathname.startsWith(PT_PREFIX + '/')) {
    return 'pt';
  }
  return DEFAULT_LOCALE;
}

export function stripLocalePrefix(pathname: string): string {
  if (pathname === EN_PREFIX) return '/';
  if (pathname.startsWith(EN_PREFIX + '/')) {
    const stripped = pathname.slice(EN_PREFIX.length);
    return stripped.length ? stripped : '/';
  }
  if (pathname === PT_PREFIX) return '/';
  if (pathname.startsWith(PT_PREFIX + '/')) {
    const stripped = pathname.slice(PT_PREFIX.length);
    return stripped.length ? stripped : '/';
  }
  return pathname || '/';
}

function ensureLeadingSlash(p: string): string {
  if (!p) return '/';
  return p.startsWith('/') ? p : '/' + p;
}

export function addLocalePrefix(path: string, locale: Locale): string {
  const normalized = ensureLeadingSlash(path);

  // Keep external/absolute URLs untouched.
  if (/^(https?:\/\/|mailto:|tel:)/i.test(normalized)) {
    return normalized;
  }

  if (locale === 'en') {
    if (normalized === '/') return EN_PREFIX;
    if (normalized === EN_PREFIX || normalized.startsWith(EN_PREFIX + '/')) return normalized;
    return EN_PREFIX + normalized;
  }

  if (locale === 'pt') {
    if (normalized === '/') return PT_PREFIX;
    if (normalized === PT_PREFIX || normalized.startsWith(PT_PREFIX + '/')) return normalized;
    return PT_PREFIX + normalized;
  }

  // Spanish default: strip /en if someone passes it.
  if (normalized === EN_PREFIX) return '/';
  if (normalized.startsWith(EN_PREFIX + '/')) {
    return normalized.slice(EN_PREFIX.length) || '/';
  }

  if (normalized === PT_PREFIX) return '/';
  if (normalized.startsWith(PT_PREFIX + '/')) {
    return normalized.slice(PT_PREFIX.length) || '/';
  }

  return normalized;
}
